import { useState, useRef, useEffect } from 'react';
import { SidebarNavItem } from '../../../types';

export const useSidebarPopper = (isCollapsed: boolean) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hoveredItem, setHoveredItem] = useState<SidebarNavItem | null>(null);
  const popperHoveredRef = useRef<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleMouseEnter = (
    e: React.MouseEvent<HTMLElement>,
    item: SidebarNavItem
  ) => {
    if (isCollapsed && item.subItems) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setAnchorEl(e.currentTarget);
      setHoveredItem(item);
    }
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (!popperHoveredRef.current) {
        setAnchorEl(null);
        setHoveredItem(null);
      }
    }, 100);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    anchorEl,
    hoveredItem,
    popperHoveredRef,
    handleMouseEnter,
    handleMouseLeave,
    setAnchorEl,
    setHoveredItem
  };
};

export default useSidebarPopper;
